import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import getDateString from '../utilities/getDateString';

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
    table: {
      minWidth: 650,
    },
  },
  formControl: {
    marginBottom: 30,
    textAlign: 'left',
  },
}));

function UserInfoCopy(props) {

  const { altUser, handleChange, label, enforceApproval } = props;
  const classes = useStyles();

  return (
    <React.Fragment>
      <div style={{
        textAlign: 'left',
        marginBottom: 40,
        background: enforceApproval ? 'rgba(255, 0, 0, 0.1)' : 'rgba(255, 255, 0, 0.1)',
        borderWidth: 4,
        borderColor: enforceApproval ? 'lightpink' : 'rgba(230, 220, 0)',
        borderStyle: 'solid',
        padding: 20,
        borderRadius: 4,
      }}>
        <Typography variant="h5" component="h2">
          {altUser.firstName} {altUser.lastName}
        </Typography>
        {altUser.customerId &&
          <Typography style={{ fontSize: 14 }} color="textPrimary" gutterBottom>
            Kundnummer: {altUser.customerId}
          </Typography>
        }
        {altUser.memberId &&
          <Typography style={{ fontSize: 14 }} color="textPrimary" gutterBottom>
            Medlemsnummer: {altUser.memberId}
          </Typography>
        }
        <Typography style={{ fontSize: 14 }} color="textPrimary">
          {altUser.membershipActive && "Förmånsmedlem till "}
          {altUser.membershipActive && getDateString(altUser.membershipExpirationTimestamp.toDate())}
        </Typography>
        {enforceApproval &&
          <FormControlLabel
            control={
              <Checkbox
                checked={altUser.reset}
                onChange={handleChange}
                name='alt-user-id'
                value={altUser.id}
                color='primary'
              />
            }
            label={label}
          />
        }
      </div>
    </React.Fragment>
  );

}

export default UserInfoCopy;